import axios from '@/axios.js'

export default {
    getAppConditionTemplates: async (extraParams, page) => {
        const response = await axios.adminapi.get(`v4/conditions/templates`,{
            params: {
                ...extraParams,
                ...(page ? { page: page } : {})
            }
        })
        return response.data.object
    },

    getAppConditionTemplate: async (uuid) => {
        const response = await axios.adminapi.get(`v4/conditions/templates/${uuid}`)
        return response.data.object
    },

    createAppConditionTemplate: async (uuid, data) => {
        const response = await axios.adminapi.post(`v4/conditions/templates/${uuid}`, data)
        return response.data.object
    },

    updateAppConditionTemplate: async (uuid, data) => {
        const response = await axios.adminapi.patch(`v4/conditions/templates/${uuid}`, data)
        return response.data.object
    },

    deleteAppConditionTemplate: async (uuid) => {
        const response = await axios.adminapi.delete(`v4/conditions/templates/${uuid}`)
        return response.data.object
    },

    getAppConditions: async (extraParams, page) => {
        const response = await axios.adminapi.get(`v4/conditions`,{
            params: {
                ...extraParams,
                ...(page ? { page: page } : {})
            }
        })
        return response.data.object
    },

    getAppCondition: async (uuid) => {
        const response = await axios.adminapi.get(`v4/conditions/${uuid}`)
        return response.data.object
    },
    
    createAppCondition: async (uuid, data) => {
        console.log(uuid)
        const response = await axios.adminapi.post(`v4/conditions`, data)
        return response.data.object
    },
    
    updateAppCondition: async (uuid, data) => {
        const response = await axios.adminapi.patch(`v4/conditions/${uuid}`, data)
        return response.data.object
    },

    getCountryDataAuthorities: async (page,extraParams) => {
        const response = await axios.adminapi.get(`v4/country-data-authorities`, {
            params: {
                ...extraParams,
                ...(page ? { page: page } : {})
            }
        })
        return response.data.object
    },
}
